module.exports = __webpack_public_path__ + "static/media/yupmedi.731ee143.svg";